import { Template } from '../templates/template';
import { Document } from '../documents/document';

export class Pack {
  public id?: string;
  public document?: Document;
  public name: string;
  public templates: Template[];
}
